import { Box, Button } from '@factorialco/deprecated-design-system'

import { ISubprojectsPanelData } from 'modules/project_management/pages/ProjectDetailsPage/tabs/SubprojectsPage/types'

import SubprojectPopoverMenuList from './PopoverMenuList'

export interface ProjectTableActionButtonsProps {
  inputedMinutes: number | undefined | null
  laborCostCents: number | null | undefined
  showSubprojectsPanel: (newData: ISubprojectsPanelData) => void
  subprojectId: number
  subprojectName: string
  canManageSubprojects: boolean
}

const ActionButtons = ({
  inputedMinutes,
  laborCostCents,
  showSubprojectsPanel,
  subprojectId,
  subprojectName,
  canManageSubprojects,
}: ProjectTableActionButtonsProps) => {
  const showPopoverMenu = subprojectId !== 0 && canManageSubprojects

  return (
    <Box flexDirection="row" gap="s8" justifyContent="flexEnd" paddingRight="s24">
      {showPopoverMenu && (
        <SubprojectPopoverMenuList subprojectId={subprojectId} subprojectName={subprojectName} />
      )}
      <Button
        disabled={!inputedMinutes}
        type="secondary"
        onClick={() => {
          const newData = {
            subprojectName,
            inputedMinutes: Number(inputedMinutes),
            laborCostCents,
            subprojectId,
          }
          showSubprojectsPanel(newData)
        }}
        iconName="arrow-right"
      />
    </Box>
  )
}

export default ActionButtons
